import { Spinner } from '@/components/shared/Spinner/Spinner'

export const SmallSpinner = () => {
  return <Spinner size="5" color="blue" />
}
